import { get_lookup_options } from "./discover_helpers"

const discover_quick_actions = [
  {
    label: "Kalshi market by ticker",
    config: {
      provider: "kalshi",
      entity: "market",
      lookup: "ticker",
    },
  },
  {
    label: "Kalshi event by ticker",
    config: {
      provider: "kalshi",
      entity: "event",
      lookup: "ticker",
    },
  },
  {
    label: "Polymarket market by id",
    config: {
      provider: "polymarket",
      entity: "market",
      lookup: "id",
    },
  },
  {
    label: "Polymarket market by slug",
    config: {
      provider: "polymarket",
      entity: "market",
      lookup: "slug",
    },
  },
  {
    label: "Polymarket event by id",
    config: {
      provider: "polymarket",
      entity: "event",
      lookup: "id",
    },
  },
  {
    label: "Polymarket event by slug",
    config: {
      provider: "polymarket",
      entity: "event",
      lookup: "slug",
    },
  },
]

const DiscoverActionPanel = ({
  action_config,
  set_action_config,
  run_single_fetch,
  discover_provider_options,
  discover_entity_options,
  is_single_loading,
}) => {
  const lookup_options = get_lookup_options(action_config.provider, action_config.entity)

  const set_config_field = (field_name, field_value) => {
    const next_action_config = {
      ...action_config,
      [field_name]: field_value,
    }

    const next_lookup_options = get_lookup_options(
      next_action_config.provider,
      next_action_config.entity
    )

    if (!next_lookup_options.includes(next_action_config.lookup)) {
      next_action_config.lookup = next_lookup_options[0]
    }

    set_action_config(next_action_config)
  }

  const execute_preset = (preset_config) => {
    const next_action_config = {
      ...action_config,
      ...preset_config,
    }

    set_action_config(next_action_config)
  }

  const placeholder_by_lookup = {
    ticker: "Enter ticker",
    id: "Enter id",
    slug: "Enter slug",
  }

  return (
    <div className="mt-0 space-y-4 rounded-lg border border-gray-200 bg-white p-4">
      <div className="text-sm font-semibold text-gray-900">Single fetch (live API)</div>
      <p className="text-xs text-gray-500">
        Does not use Redis bulk cache. Calls Kalshi or Polymarket directly for one market or event.
      </p>

      <div>
        <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
          Quick actions
        </div>
        <div className="flex flex-wrap gap-2">
          {discover_quick_actions.map((quick_action) => (
            <button
              type="button"
              key={quick_action.label}
              className="rounded-md border border-gray-300 bg-white px-3 py-1.5 text-xs font-semibold text-gray-700 hover:border-blue-300 hover:text-blue-700 disabled:cursor-not-allowed disabled:opacity-60"
              onClick={() => execute_preset(quick_action.config)}
              disabled={is_single_loading}
            >
              {quick_action.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
        <select
          className="rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900"
          value={action_config.provider}
          onChange={(e) => set_config_field("provider", e.target.value)}
          disabled={is_single_loading}
        >
          {discover_provider_options.map((provider) => (
            <option key={provider} value={provider}>{provider}</option>
          ))}
        </select>

        <select
          className="rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900"
          value={action_config.entity}
          onChange={(e) => set_config_field("entity", e.target.value)}
          disabled={is_single_loading}
        >
          {discover_entity_options.map((entity) => (
            <option key={entity} value={entity}>{entity}</option>
          ))}
        </select>

        <select
          className="rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900"
          value={action_config.lookup}
          onChange={(e) => set_config_field("lookup", e.target.value)}
          disabled={is_single_loading}
        >
          {lookup_options.map((lookup) => (
            <option key={lookup} value={lookup}>{lookup}</option>
          ))}
        </select>
      </div>

      <div className="grid grid-cols-1 gap-3 md:grid-cols-6">
        <input
          type="text"
          className="md:col-span-5 rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900 placeholder:text-gray-400"
          value={action_config.identifier}
          onChange={(e) => set_config_field("identifier", e.target.value)}
          placeholder={placeholder_by_lookup[action_config.lookup] || "Enter identifier"}
          disabled={is_single_loading}
        />
        <button
          type="button"
          className="rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 disabled:cursor-not-allowed disabled:opacity-60"
          onClick={() => run_single_fetch()}
          disabled={is_single_loading}
        >
          {is_single_loading ? "Loading..." : "Run fetch"}
        </button>
      </div>
    </div>
  )
}

export default DiscoverActionPanel
